export enum eHOAFees {
  working_capital = 'working_capital',
  prepaid_assessment = 'prepaid_assessment',
  special_assessment = 'special_assessment',
  disclosure_fee = 'disclosure_fee',
  transfer_fee = 'transfer_fee',
  service_fee = 'service_fee',
}
